import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  momentumStatus?: 'Building' | 'Maintaining' | 'Declining';
}

const Card: React.FC<CardProps> = ({ className = '', children, momentumStatus, ...props }) => {
  let gradientClass = '';
  if (momentumStatus === 'Building') gradientClass = 'bg-momentum-building';
  else if (momentumStatus === 'Maintaining') gradientClass = 'bg-momentum-maintaining';
  else if (momentumStatus === 'Declining') gradientClass = 'bg-momentum-declining';

  const classes = `glass ${gradientClass} shadow-glass p-8 md:p-10 ${className}`;
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

const CardContent: React.FC<CardProps> = ({ className = '', children, ...props }) => {
  const classes = `p-5 ${className}`;
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export { Card, CardContent }; 